import { getReportParams, report } from '../../../../middleware/report';

export const DWHStatus = {
  Ongoing: 'Ongoing',
  Completed: 'Completed',
  Error: 'Error',
};

export const DwhActionType = {
  ChoosePackagePage: 'Choose package Page',
  PopupNoSignature: 'Popup No Signature',
  PopupAbroadPackage: 'Popup Abroad Package',
  ErrorLineOwnerPostponed: 'Error Line Owner postponed',
  ErrorLineOwnerBNIYOD: 'Error Line Owner BNIYOD',
  ErrorLinkIsNotValid: 'Error Link is not valid',
  ErrorLineOwnerIsAbroad: 'Error Line Owner is abroad',
  EquipmentChargesPage: 'Equipment Charges page',
  AnotherServicePage: 'Another Service page',
  ChooseBanPage: 'Choose Ban page',
  DetailPage: 'Detail page',
  AddressPage: 'Address page',
  PaymentMethodPage: 'Payment Method page',
  SuccessScreen: 'Success Screen',
  ErrorScreen: 'Error Screen',
};
export const DWHMessageText = {
  ChoosePackagePageDisplayed: 'Choose package Page Displayed',
  ChoosePackagePageButtonClicked: 'Choose package Page Button Clicked',
  PopupNoSignatureDisplayed: 'Popup No Signature Displayed',
  PopupAbroadPackageDisplayed: 'Popup Abroad Package Displayed',
  ErrorLineOwnerPostponedDisplayed: 'Error Line Owner postponed Displayed',
  ErrorLineOwnerBNIYODDisplayed: 'Error Line Owner BNIYOD Displayed',
  ErrorLinkIsNotValidDisplayed: 'Error Link is not valid Displayed',
  ErrorLineOwnerIsAbroadDisplayed: 'Error Line Owner is abroad Displayed',
  EquipmentChargesPageDisplayed: 'Equipment Charges page Displayed',
  EquipmentChargesPageButtonClicked: 'Equipment Charges page Button Clicked',
  AnotherServicePageDisplayed: 'Another Service page Displayed',
  AnotherServicePageYesButtonClicked: 'Another Service page Yes Button Clicked',
  AnotherServicePageNoButtonClicked: 'Another Service page No Button Clicked',
  ChooseBanPageDisplayed: 'Choose Ban page Displayed',
  ChooseBanPageButtonClicked: 'Choose Ban page Button Clicked',
  DetailPageDisplayed: 'Detail page Displayed',
  DetailPageButtonClicked: 'Detail page Button Clicked',
  AddressPageDisplayed: 'Address page Displayed',
  AddressPageClicked: 'Address page Clicked',
  AddressPageSignatureButtonClicked: 'Address pag esignature Button Clicked',
  PaymentMethodPageDisplayed: 'Payment Method page Displayed',
  PaymentMethodPageButtonClicked: 'Payment Method page Button Clicked',
  SuccessScreen: 'Success Screen',
  SuccessScreenCellcomDO: 'Success Screen - Cellcom DO', //???
  GeneralError: 'General Error',
  //Error Payment
};

function getEquipmentTitle(data) {
  if (data.currentEquipmentObligations.length > 0) {
    return 'העברת ציוד - כן';
  } else {
    return 'העברת ציוד - לא';
  }
}

export function dwhGeneralReport({ data, actionType, messageText, status }) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'OwnershipTransfer - Line Owner';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = actionType;
  reportParams.status = status;
  reportParams.messageText = messageText;
  //reportParams.param1 = data.portalsBlock.selectedHetPay;
  reportParams.param2 = data.customerPhoneNumber;
  reportParams.param7 = getEquipmentTitle(data);
  //reportParams.param8 = data.portalsBlock.selectedOrgName;
  reportParams.idNumber = data.userDetails?.IDNumber;
  reportParams.customerName = `${data.userDetails?.firstName} ${data.userDetails?.lastName}`;
  reportParams.subscriber = data.userDetails?.contactNumber;
  report(reportParams);
}
